import { StrictMode } from 'react'
import { Providers } from '@/app/providers'
import { createRoot } from 'react-dom/client'

import "./i18n"

import "@fontsource-variable/geist/index.css"
import "@fontsource-variable/geist-mono/index.css"
import './styles/globals.css'

import { AppRouter } from './app/router'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Providers>
      <AppRouter />
    </Providers>
  </StrictMode>,
)